import React from 'react';

import { IconProps } from 'icons/Icon.types';

export function Home({ size, color }: IconProps) {
  return (
    <svg
      width={size ?? 24}
      height={size ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Home</title>
      <path
        d="M12.7067 4.70711L12.1763 5.23744L12.7067 4.70711ZM17.636 9.63644L18.1663 9.10611L17.636 9.63644ZM17.4718 11.0506V18H18.9718V11.0506H17.4718ZM6.52734 18V11.0507H5.02734V18H6.52734ZM6.89346 10.1668L11.8228 5.23744L10.7621 4.17678L5.8328 9.10611L6.89346 10.1668ZM16.2218 19.25H11.9996V20.75H16.2218V19.25ZM11.9996 19.25H7.77734V20.75H11.9996V19.25ZM12.1763 5.23744L17.1057 10.1668L18.1663 9.10611L13.237 4.17678L12.1763 5.23744ZM11.8228 5.23744C11.9204 5.13981 12.0787 5.13981 12.1763 5.23744L13.237 4.17678C12.5536 3.49336 11.4455 3.49336 10.7621 4.17678L11.8228 5.23744ZM5.02734 18C5.02734 19.5188 6.25856 20.75 7.77734 20.75V19.25C7.08699 19.25 6.52734 18.6904 6.52734 18H5.02734ZM17.4718 18C17.4718 18.6904 16.9121 19.25 16.2218 19.25V20.75C17.7406 20.75 18.9718 19.5188 18.9718 18H17.4718ZM18.9718 11.0506C18.9718 10.3213 18.6821 9.62183 18.1663 9.10611L17.1057 10.1668C17.3401 10.4012 17.4718 10.7191 17.4718 11.0506H18.9718ZM6.52734 11.0507C6.52734 10.7191 6.65904 10.4012 6.89346 10.1668L5.8328 9.10611C5.31707 9.62183 5.02734 10.3213 5.02734 11.0507H6.52734Z"
        fill={color ?? 'currentColor'}
      />
    </svg>
  );
}
